/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var UserSecIcon = createIcon({
  name: 'UserSecIcon',
  height: 1024,
  width: 878,
  svgPath: 'M657.262 657.92c0-120.978-98.085-219.063-219.063-219.063s-219.063 98.085-219.063 219.063c0 120.978 98.085 219.063 219.063 219.063s219.063-98.085 219.063-219.063zM38.766-73.143c7.826 102.327 37.303 305.737 148.041 389.559v0c0 0 59.758 50.322 150.821 49.883l201.143 0.366c91.136 0 150.821-50.322 150.821-50.322s133.12-88.722 149.285-389.559z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default UserSecIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/user-sec-icon.js
// module id = 1124
// module chunks = 0